export default __webpack_public_path__ + "static/media/1.49fac374.jpg";